"use client";

import { useEffect } from "react";

// 화면 렌더링 오류 방지벽 (2026-08-09 신설).
// 없으면 렌더 중 오류가 났을 때 방문자가 영어 오류 화면을 보게 된다.
// captureException은 렌더 오류를 Sentry에 확실히 남기려는 것 —
// 이벤트 핸들러 오류는 로더 스크립트가 이미 잡는 것을 실측 확인했고(중복은 Sentry가 한 건으로 묶는다),
// 렌더 중 오류는 이 방지벽이 삼키므로 여기서 직접 알려야 한다.
export default function HomepageError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    (window as unknown as { Sentry?: { captureException: (e: unknown) => void } }).Sentry?.captureException(error);
  }, [error]);

  return (
    <main style={{ padding: "80px 24px", textAlign: "center" }}>
      <h1 style={{ fontSize: 20, marginBottom: 12 }}>화면을 여는 중 문제가 생겼습니다</h1>
      <p style={{ color: "#6b7280", fontSize: 15, marginBottom: 20 }}>
        잠시 후 다시 시도해 주세요. 급하시면 051-899-7833으로 연락 주세요.
      </p>
      <button
        type="button"
        onClick={() => reset()}
        style={{ padding: "10px 24px", borderRadius: 8, border: "1px solid #d1d5db", background: "#49AC35", color: "#fff", cursor: "pointer", fontSize: 15 }}
      >
        다시 시도
      </button>
    </main>
  );
}
